export enum Permission{
  Admin = 'isAdmin',
  Contributor = 'isContributor',
  Reviewer = 'isReviewer',
}
